import { Injectable, inject } from '@angular/core';
import { parseISO } from 'date-fns';
import { Observable, tap } from 'rxjs';
import { IBankDto, IChangePasswordDto, IConciseCountryDto, ICustomerDto, ISignupDto, IUpdateProfileDto, IUpdateUserDto } from 'src/app/contracts/api.types';
import { IRegister } from 'src/app/contracts/app.types';
import { Api } from 'src/app/core/common/api';
import { IApiOptions } from 'src/app/core/contracts';

@Injectable({ providedIn: 'root' })
export class UserData {
  private api = inject(Api);

  signup(params: ISignupDto): Observable<ISignupDto> {
    return this.api.post('users/signup', {
      ...params,
      firstName: params.firstName?.trim(),
      lastName: params.lastName?.trim(),
      email: params.email?.trim(),
    } as ISignupDto);
  }
  getCustomer(options?: IApiOptions): Observable<ICustomerDto> {
    return this.api.get<ICustomerDto>('users/profile', options).pipe(
      tap(user => {
        if (user) {
          user.dateOfBirth = user.dateOfBirth ? parseISO(user.dateOfBirth as string) : null;
        } else {
          // null if PLACEHOLDER_CUSTOMER
        }
      })
    );
  }

  update(data: IUpdateUserDto) {
    return this.api.update('users', data);
  }
  delete(phone: string, name: string) {
    return this.api.delete('users', { phone, name });
  }
  registerUser(data: IRegister) {
    return this.api.post('Legacy/Account/Signup', data);
  }
  public changePassword(data: IChangePasswordDto) {
    return this.api.post('Legacy/Account/ChangePassword', data);
  }

  public getAllCountries(): Observable<IConciseCountryDto[]> {
    return this.api.get('Countries');
  }
  public getAllBanks(): Observable<IBankDto[]> {
    return this.api.get('Legacy/Account/GetBanks');
  }
  getCurrentProfile(): Observable<IUpdateProfileDto> {
    return this.api.get('Legacy/Account/MyProfile');
  }
  updateProfile(data: IUpdateProfileDto) {
    return this.api.update('Legacy/Account/Update', data);
  }

  public CheckNationalId(): Observable<string> {
    return this.api.get('Legacy/Account/CheckNationalId', { handleLoading: false });
  }

  public SetNationalId(nationalId): Observable<void> {
    return this.api.post('Legacy/Account/SetNationalId', { nationalId });
  }
}
